import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-folder",
  templateUrl: "./med-icon-folder.component.html",
})
export class MedIconFolderComponent extends SvgMixinComponent {}
